import "./MapViewPage.scss";
import React, { useEffect, useState, useRef } from "react";
import {
  MapIcon,
  EditIcon,
  HandIcon,
  InfoIcon,
  LayerIcon,
  RotateLeft,
  LegendIcon,
  WorldIcon,
} from "../../assets/icons/index";
import { SelectComune } from "../../Components/MapView/SelectComune/SelectComune.jsx";
import {
  BackgroundMap,
  LayersCard,
  Legend,
  ManageLayers,
  SocialIcon,
  DeleteLayers,
  EditLayers,
  UploadedFileInfo,
} from "../../Components/index";
import { OLMap } from "../../Components/MapView/openLayerMap/openLayerMap.jsx";
import ReactModal from "../../Components/ReactModal/ReactModal";
import LayerUploadModal from "../../Components/MapView/LayerUploadModal/LayerUploadModal.jsx";
import LayerEditModal from "../../Components/MapView/LayerEditModal/LayerEditModal.jsx";
import backgroundMaps from "../../constants/backgroundMaps";
import { useAppContext } from "../../Components/Context/AppContext";
import userHasPermission  from "../../helpers/formTools/userHasPermission/index.js";
import FeatureSummary from "../../Components/FeatureSummary";
import { toast } from "react-toastify";
import { deleteLayer,getComuni } from "../../api";

const socialIcons = [
  {
    icon: <MapIcon />,
    isProtected: false,
    label: "Seleziona il sito o il comune",
    isVisible: true,
  },
  {
    icon: <LayerIcon />,
    isProtected: false,
    label: "Seleziona i layer",
    isVisible: true,
  },
  {
    icon: <LegendIcon />,
    isProtected: true,
    label: "Legenda",
    isVisible: false,
  },
  /*
  {
    icon: <HandIcon />,
    isProtected: false,
    label: "Sposta la mappa",
    isVisible: true,
  },
  */
  {
    icon: <InfoIcon />,
    isProtected: false,
    label: "Informazioni feature",
    isVisible: true,
  },
  {
    icon: <EditIcon />,
    isProtected: true,
    label: "Gestisci Layer",
    isVisible: true,
  },
  {
    icon: <WorldIcon />,
    isProtected: false,
    label: "Cambia mappa di sfondo",
    isVisible: true,
  },
  {
    icon: <RotateLeft />,
    isProtected: false,
    label: "Reset",
    isVisible: true,
  },
];

const legends = ["Layer 1", "Layer 2", "Layer 3"];

export default function MapViewPage() {
  const { comuni, layers, setComuni, setLayers, userProfile } = useAppContext();
  const [currentSelectedSocialIcon, setCurrentSelectedIcon] = useState(-1);
  const [isDeleteLayerVisible, setDeleteLayerVisible] = useState(false);
  const [isUploadFileVisible, setUploadFileVisible] = useState(false);
  const [isEditLayersVisible, setEditLayersVisible] = useState(false);
  const [isEditLayerModalVisible, setEditLayerModalVisible] = useState(false);  
  const [currentLayerData, setCurrentLayerData] = useState(null);
  const [uploadedFile, setUploadedFile] = useState({});
  const [isFileUploaded, setFileUploaded] = useState(false);
  const [layersMenu, setLayersMenu] = useState([]);
  const organization = JSON.parse(localStorage.getItem("organization"));
  const [selectedComune, setSelectedComune] = useState(organization?.comune);
  const [properties, setProperties] = useState(null);
  const [isEyeOpen, setIsEyeOpen] = useState(true);
  const [legendStyle, setLegendStyle] = useState("");
  const [subChild, setSubChild] = useState("");
  const [isSelected, setIsSelected] = useState();
  const [title, setTitle] = useState({});
  const titleRef = useRef({});
  const [selectedBackgroundMap, setBackgroundMap] = useState(backgroundMaps[0]);

  const [selectedLayer, setSelectedLayer] = useState(null);
  const { mapViewTarget, setMapViewTarget } = useAppContext();
  const defaultTarget = { layer: organization?.comune?.nome === 'ITALIA' ? "comuni" : "limiti", comune: organization?.comune };

  // CHECK IF USER HAS GIS PRIVILEGES
  const isGisManager = userHasPermission({userProfile, organization, resource: 'layer', resourceGroups: null, permission: 'write'});

  const listComuni = async () => {
    try {
      const data = await getComuni([
        { key: "pageSize", value: 1000 },
        { key: "page", value: 1 },
        { key: "sort", value: "nome,asc" },
      ]);
      if (Array.isArray(data.results)) {
        setComuni(data.results.filter((comune) => comune.nome !== "ITALIA"));
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.error(`Authorization error fetching "comuni"`);
      } else {
        console.error(`Error fetching "comuni"`, error);
      }
    }
  };



  // GET THE UPDATED LIST OF MUNICIPALITIES
  useEffect(() => {
    listComuni();
    return () => {};
  }, []);

  // Set mapViewTarget only if it's empty
  useEffect(() => {
    // Check if mapViewTarget is empty (empty array, null, undefined, or missing properties)
    const isEmpty = !mapViewTarget || 
                     (Array.isArray(mapViewTarget) && mapViewTarget.length === 0) ||
                     (typeof mapViewTarget === 'object' && (!mapViewTarget.layer || !mapViewTarget.comune));
    
    if (isEmpty && defaultTarget.comune) {
      setMapViewTarget(defaultTarget);
    }
  }, []); // Run only once on mount

  // UPDATE LAYERS MENU
  useEffect(() => {
    const layersMenu = layers?.map((layer) => {
      console.log("===| !! layer ??", layer);
      return {
        id: layer.id,
        title: layer.tipo,
        isVisible: layer.vectorLayer.getVisible(),
        isChecked: false,
        onFocus: false,
        style: layer.style,
        colors: layer.colors,
        chiave: layer.chiave,
        tipo: layer.tipo,
        crs: layer.crs
      };
    });
    setLayersMenu(layersMenu);
  }, [layers]);

  const [layerTitle, setLayerTitle] = useState("");
  let currentSocialToolTipOpen = <></>;

  const handleFeatureProperties = (...values) => {
    setProperties(...values);
    setCurrentSelectedIcon(4);
  };

  const handleSelectedComune = (comune) => {
    setSelectedComune(comune);
    setMapViewTarget({ layer: comune?.nome === 'ITALIA' ? "comuni" : "limiti", comune: comune });
  };

  const handleLegendImage = (props) => {
    setLegendStyle(props);
  };

  const handleSelectedLayer = (data) => {
    console.log("===| !! handleSelectedLayer data", data);
    setEditLayersVisible(false);
    setEditLayerModalVisible(true);
    setCurrentLayerData(data);
  };

  //  **** HANDLE LAYER VISIBILITY  ****
  const handleCallBackLayerVisibility = (props) => {
    setSubChild(props);
    const selected = layers.find((layer) => layer.tipo === props.title);
    if (selected) {
      selected.vectorLayer.setVisible(props.isVisible);
      setLayersMenu((prev) =>
        prev.map((layer) => {
          return layer.title === selected.tipo
            ? { ...layer, isVisible: props.isVisible }
            : layer;
        })
      );
    }
  };

  const handleCallBackCheckLayer = (props) => {
    const selected = layers.find((layer) => layer.tipo === props.title);
    if (selected) {
      setLayersMenu((prev) =>
        prev.map((layer) => {
          return layer.title === selected.tipo
            ? { ...layer, isChecked: props.isChecked }
            : layer;
        })
      );
    }
  };

  const handleCallBackLayerTitle = (props) => {
    setLayerTitle(props.layerTitle);
  };

  const handleDeleteLayers = async () => {
    const token = localStorage.getItem("authToken");
    let removed = false;
    layersMenu
      ?.filter((layer) => layer.isChecked)
      .forEach(async (layer) => {
        let success = true;
        try {
          await deleteLayer(layer.id);
        } catch (err) {
          toast.error(`Error: ${err.message}`);
          console.error(err);
          success = false;
        } 
        if (success) {
          setDeleteLayerVisible(false);
          toast.success(`Layer ${layer.title} eliminato con successo`);
          setLayers(layers.filter((l) => layer.id !== l.id));
          removed = true;
        }
      });
    if (removed) {
      setTimeout(() => {
        console.log(">>> RELOADING MAP VIEW PAGE");
        window.location.reload();
      }, 20); // 2000 milliseconds = 2 seconds
    }
  };


  const handleCallBackTitle = (props) => {
    setIsSelected(props.isSelected);
    setTitle(props.title);
  };
  const handleOnCloseSocialIcon = () => {
    setCurrentSelectedIcon(-1);
  };
  const handleOnNextFeatureClick = () => {};
  const handleOnMinimizeFeature = () => {};

  const handleOnClickSocialIcon = (index) => {
    setCurrentSelectedIcon(index);
  };
  switch (currentSelectedSocialIcon) {
    case 0: {
      currentSocialToolTipOpen = (
        <SelectComune
          oselectedComune={selectedComune}
          handleOnCloseSocialIcon={handleOnClickSocialIcon}
          onSelectComune={handleSelectedComune}
          setLayers={setLayers}
        />
      );
      break;
    }
    case 1: {
      currentSocialToolTipOpen = (
        <LayersCard
          title={`${selectedComune.nome}: layer disponibili`}
          // layers={layers}
          layersMenu={layersMenu}
          hasEyes={true}
          // dataList={layersDataList}
          crossClickHandler={handleOnCloseSocialIcon}
          className="municipality-info-card-wrapper"
          handleCallBackLayerVisibility={handleCallBackLayerVisibility}
          handleCallBackLayerTitle={(value) => {
            handleCallBackLayerTitle(value);
          }}
          handleCallBackTitle={(value) => {
            handleCallBackTitle(value);
          }}
          mainTitle={title}
          layerTitle={layerTitle}
        />
      );
      break;
    }
    case 2: {
      currentSocialToolTipOpen = (
        <Legend
          legends={legends}
          onCrossClick={handleOnCloseSocialIcon}
          legendStyle={legendStyle}
        />
      );
      break;
    }
    case 3: {
      currentSocialToolTipOpen = <></>;
      break;
    }
    case 4: {
      currentSocialToolTipOpen = (
        <FeatureSummary
          closeClick={handleOnCloseSocialIcon}
          minimizeClick={handleOnMinimizeFeature}
          nextClick={handleOnNextFeatureClick}
          properties={properties}
        />
      );
      break;
    }
    case 5: {
      currentSocialToolTipOpen = (
        <ManageLayers
          onCrossClick={handleOnCloseSocialIcon}
          onDeleteClick={() => {
            setDeleteLayerVisible(true);
            handleOnCloseSocialIcon();
          }}
          onUploadFile={() => {
            setUploadFileVisible(true);
            handleOnCloseSocialIcon();
          }}
          onEditLayers={() => {
            setEditLayersVisible(true);
            handleOnCloseSocialIcon();
          }}
        />
      );
      break;
    }
    case 6: {
      currentSocialToolTipOpen = (
        <BackgroundMap
          onClose={handleOnCloseSocialIcon}
          onSelect={(backgroundMap) => {
            setBackgroundMap(backgroundMap);
          }}
          backgroundMaps={backgroundMaps}
        />
      );
      break;
    }
    case 7: {
      currentSocialToolTipOpen = <></>;
      handleSelectedComune(organization?.comune);
      setCurrentSelectedIcon(-1);
      break;
    }
    default: {
      currentSocialToolTipOpen = <></>;
    }
  }
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
      setUploadFileVisible(false);
      setFileUploaded(true);
    }
  };

  const closeReactModal = () => {
    if (isUploadFileVisible) {
      setUploadFileVisible(false);
    } else if (isDeleteLayerVisible) {
      setDeleteLayerVisible(false);
    } else if (isFileUploaded) {
      setFileUploaded(false);
    }
  };


  return (
    <>
      <main className="map-view-main-container">
        <div className="ol-map-container-wrapper-class">
          <OLMap
            backgroundMap={selectedBackgroundMap} // checked ok
            className="ol-map-container" // ?
            handleCallBackLayerTitle={(layerTitle) =>
              handleCallBackLayerTitle({ layerTitle })
            } //??
            handleCallBackTitle={(Title) => handleCallBackTitle({ Title })} // ??
            handleFeatureProperties={handleFeatureProperties} // indentity on map (??)
            isEyeOpen={isEyeOpen} // ?
            title={title} // ?
            layerTitle={layerTitle} //. ?
            handleLegendImage={(value) => {
              // ??
              handleLegendImage(value);
            }}
            mapViewTarget={mapViewTarget || defaultTarget}
            titleRef={titleRef.current} // ?
            isSelected={isSelected} // ?
            selectedComune={selectedComune} // checked ok
            setSelectedComune={setSelectedComune} // checkedok
            layers={layers} // checked ok
            setLayers={setLayers} // checked ok
          ></OLMap>
        </div>
        <aside className="sidebar">
          {socialIcons.map(({ icon, isProtected, label, isVisible }, index) => {
            if (!isVisible || (isProtected && !isGisManager)) return null;
            return (
              <SocialIcon
                key={index}
                icon={React.cloneElement(icon, {
                  fillColor:
                    currentSelectedSocialIcon === index
                      ? "#fff"
                      : "var(--archeo-color)",
                })}
                isActive={index === currentSelectedSocialIcon}
                onClick={() => {
                  handleOnClickSocialIcon(index);
                }}
                label={label}
              />
            );
          })}
        </aside>
        {currentSocialToolTipOpen}
        <ReactModal
          isOpen={isDeleteLayerVisible || isUploadFileVisible || isFileUploaded || isEditLayersVisible || isEditLayerModalVisible}
          onClose={closeReactModal}
        >
          {isUploadFileVisible && (
            <LayerUploadModal
              title="UPLOAD RECORD (ONE AT A TIME)"
              selectedComune={selectedComune}
              closeModal={() => setUploadFileVisible(false)}
              handleFileUpload={handleFileUpload}
            />
          )}
          {isEditLayerModalVisible && (
            <LayerEditModal
              title="EDIT LAYER"
              currentLayerData={currentLayerData}
              selectedComune={selectedComune}
              closeModal={() => setEditLayerModalVisible(false)}
            />
          )}
          {isDeleteLayerVisible && (
            <DeleteLayers
                layersMenu={layersMenu}
                handleCallBackCheckLayer={handleCallBackCheckLayer}
                crossClickHandler={() => setDeleteLayerVisible(false)}
                onDelete={handleDeleteLayers}
                onCancel={() => setDeleteLayerVisible(false)}
              />
            )}
          {isEditLayersVisible && (
            <EditLayers
              layersMenu={layersMenu}
              onCancel={() => setEditLayersVisible(false)}
              crossClickHandler={() => setEditLayersVisible(false)}
              onEditLayer={handleSelectedLayer}
            />
          )}
          {isFileUploaded && (
            <UploadedFileInfo
              fileName={uploadedFile?.name}
              onCross={() => setFileUploaded(false)}
              onAddLayer={() => setFileUploaded(false)}
              onCancel={() => setFileUploaded(false)}
            />
          )}
        </ReactModal>
      </main>
    </>
  );
}
